import { StoreState } from '@urrobot/web/src/store';
import { Store } from 'vuex';

export const resolveStore = (
) => import('@urrobot/web/src/store').then((r) => r.asyncStore);
